import { useState } from 'react';
import { Button, Card } from 'react-bootstrap';
import { Navigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { PageHeading } from '../components/common/PageHeading';
import { ConfirmDialog } from '../components/common/ConfirmDialog';
import { FormAlert } from '../components/form';
import { post } from '../lib/api';
import { logoutUser, useAuthDispatch, useAuthState } from '../auth/AuthContext';
import { useTokenEmail } from '../auth/useTokenEmail';
import { isAdUser } from '../auth/roles';
import { Paths } from '../routes/paths';
import { usePageTitle } from '../lib/usePageTitle';

export function ProfilePage() {
    const { t } = useTranslation();
    const auth = useAuthState();
    const dispatch = useAuthDispatch();
    const isAd = isAdUser(auth);
    usePageTitle(t('profile.title'));

    const email = useTokenEmail();
    const [show, setShow] = useState(false);
    const [deleting, setDeleting] = useState(false);
    const [error, setError] = useState('');
    const [done, setDone] = useState(false);

    async function confirmDelete() {
        setDeleting(true);
        setError('');
        try {
            await post('login/DeleteAccount', {});
            logoutUser(dispatch);
            setDone(true);
        } catch {
            setError(t('profile.deleteError'));
            setDeleting(false);
        }
    }

    if (done) return <Navigate to={Paths.login} replace />;

    return (
        <>
            <PageHeading title={t('profile.title')} />

            <Card body className="shadow-sm" style={{ maxWidth: '34rem' }}>
                <dl className="row mb-0">
                    <dt className="col-sm-4 text-body-secondary fw-normal">{t('profile.email')}</dt>
                    <dd className="col-sm-8 mb-0">{email || '—'}</dd>
                </dl>

                {isAd ? (
                    <p className="text-body-secondary small mt-4 mb-0">{t('profile.adManaged')}</p>
                ) : (
                    <div className="mt-4 pt-3 border-top">
                        <h2 className="h6 text-danger">{t('profile.dangerZone')}</h2>
                        <p className="text-body-secondary small">{t('profile.deleteHint')}</p>
                        <Button variant="outline-danger" onClick={() => setShow(true)}>
                            {t('profile.deleteAccount')}
                        </Button>
                    </div>
                )}
            </Card>

            <ConfirmDialog
                show={show}
                title={t('profile.deleteAccount')}
                confirmLabel={t('profile.proceed')}
                onCancel={() => setShow(false)}
                onConfirm={confirmDelete}
                confirmDisabled={deleting}
            >
                <FormAlert onClose={() => setError('')}>{error || undefined}</FormAlert>
                {t('profile.confirmDelete')}
            </ConfirmDialog>
        </>
    );
}
